var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container padding"},[_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.content))]),_c('div',{staticClass:"card-btn",on:{"click":_vm.goTrial}},[_vm._v(_vm._s(_vm.btn)+">")])])
}
var staticRenderFns = []

export { render, staticRenderFns }